module.exports = __webpack_public_path__ + "static/media/interview21.c482b521.jpg";